export function titleCase(text) {
    const exceptions = ['the', 'and', 'an', 'a', 'of', 'in', 'to', 'at', 'on', 'for', 'with', 'but', 'or', 'nor'];
    const words = text?.toLowerCase()?.split(' ');

    const result = words.map((word, index) => {
        // Always capitalize the first word, even if it's in the exceptions list
        if (index === 0 || !exceptions.includes(word)) {
            return word?.charAt(0)?.toUpperCase() + word?.slice(1);
        }
        return word;
    });

    return result.join(' ');
}

export const fixedNumber = (number = 0) => {
    return Number(Number(number)?.toFixed(2))
}

export const roundedNumber = (number) => {
    if (!number || isNaN(number)) return 0;
    return Math.round(number);
}

export const formatQuesNumber = (str) => {
    return str?.replace(/\.0(\d)/, '.$1');
}

export const parseIfStringify = (string) => {
    try {
        return JSON.parse(string);
    } catch (error) {
        return string;
    }
}

export const removeSpaceAndUppercase = (text) => {
    return text?.replace(/\s/g, '')?.toUpperCase();
}